import { Routes } from '@angular/router';
import { Permission } from '@vdms-hq/auth';

export const FIELDS_SERVICE_ROUTING: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/fields-service-page/fields-service-page.component').then((m) => m.FieldsServicePageComponent),
    data: {
      permissions: [Permission.BROWSE_FIELDS, Permission.BROWSE_FIELD_TYPES],
      operator: 'every',
    },
  },
];

export const FIELDS_SERVICE_ADMIN_ROUTING: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/fields-service-page-admin/fields-service-page-admin.component').then(
        (m) => m.FieldsServicePageAdminComponent,
      ),
  },
];
